// components/RekapanCard.jsx
import React from 'react';

const RekapanCard = ({ items, startDate, endDate }) => {
  const dataKaryawan = JSON.parse(localStorage.getItem('data_karyawan') || '{}');
  const isFreelance = String(dataKaryawan.status || '').trim().toLowerCase() === 'freelance';

  // === HITUNG REKAPAN ABSEN ===
  const count = items.reduce(
    (acc, item) => {
      const id = parseInt(item.absen_id);
      const masuk = item.masuk || item.jam_masuk;
      const pulang = item.pulang || item.jam_pulang;
      const telat = parseInt(item.telat || 0);
      const bolos = parseInt(item.bolos || 0);
      const uangMakan = parseFloat(item.uang_makan || 0);

      // 1. Belum Lengkap = masuk atau pulang kosong
      if (id === 18 && (!masuk || !pulang)) {
        acc.belumLengkap++;
      }

      // 2. Absen Normal
      const isAbsenSahNormal =
        id === 18 && masuk && pulang && telat === 0 && bolos === 0;

      // 3. Absen Toleransi (uang makan 12500)
      const isAbsenSahToleransi =
        id === 18 && masuk && uangMakan === 12500;

      // Total absen sah
      if (isAbsenSahNormal || isAbsenSahToleransi) {
        acc.absenSah++;
      }

      // Toleransi
      if (isAbsenSahToleransi) {
        acc.toleransi++;
      }

      // Telat atau bolos
      if (id === 18 && (telat > 0 || bolos > 0)) {
        acc.telatBolos++;
      }

      // Kategori Utama
      switch (id) {
        case 18:
          acc.berangkat++;
          break;
        case 11:
          acc.dinas++;
          break;
        case 7:
          acc.libur++;
          break;
        case 25:
          acc.libur++;
          break;
        case 6:
          acc.sakit++;
          break;
        case 8:
          acc.piket++;
          break;
        case 14:
          acc.setengahHari++;
          break;
        case 26:
          acc.cuti++;
          break;
        default:
          acc.cuti++;
      }

      return acc;
    },
    {
      berangkat: 0,
      dinas: 0,
      libur: 0,
      sakit: 0,
      piket: 0,
      setengahHari: 0,
      cuti: 0,
      absenSah: 0,
      belumLengkap: 0,
      telatBolos: 0,
      toleransi: 0,
    }
  );

  // Total uang makan
  const totalUangMakan = count.absenSah * 12500;

  // Format Rupiah
  const formatRupiah = (nominal) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(nominal);

  // === HITUNG PERIODE ===
  const getPeriode = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const date = today.getDate();

    let start, end;

    if (date >= 21) {
      start = new Date(year, month, 21);
      const nextMonth = month === 11 ? 0 : month + 1;
      const nextYear = month === 11 ? year + 1 : year;
      end = new Date(nextYear, nextMonth, 20);
    } else {
      const prevMonth = month === 0 ? 11 : month - 1;
      const prevYear = month === 0 ? year - 1 : year;
      start = new Date(prevYear, prevMonth, 21);
      end = new Date(year, month, 20);
    }

    // Override dari props
    if (startDate && endDate) {
      start = new Date(startDate);
      end = new Date(endDate);
    }

    return { start, end };
  };

  const { start, end } = getPeriode();

  const totalDaysInPeriod =
    Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

  const daysWithData = new Set(
    items.map((i) => i.tanggal || i.tgl_ijin)
  ).size;

  const attendanceRate =
    totalDaysInPeriod > 0
      ? Math.round((daysWithData / totalDaysInPeriod) * 100)
      : 0;

  const formatPeriode = () => {
    const opt = { day: "numeric", month: "long", year: "numeric" };
    return `${start.toLocaleDateString("id-ID", opt)} – ${end.toLocaleDateString(
      "id-ID",
      opt
    )}`;
  };

  // ========================= UI =========================
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #003087, #0052cc)",
        color: "#fff",
        padding: "18px 20px",
        borderRadius: 24,
        margin: "0 0 24px 0",
        boxShadow: "0 6px 20px rgba(0,48,135,0.25)",
        fontSize: 13,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
        gap: 14,
        textAlign: "center",
      }}
    >
      {[
        { label: "Hari", value: totalDaysInPeriod },
        { label: "Berangkat", value: count.berangkat },
        { label: "Absen Sah", value: count.absenSah, highlight: true },
        { label: "Blm Lengkap", value: count.belumLengkap, color: "#fb923c" },
        { label: "Telat/Bolos", value: count.telatBolos, color: "#f87171" },
        { label: "Toleransi", value: count.toleransi, color: "#34d399" },
        { label: "Dinas", value: count.dinas },
        { label: "Libur", value: count.libur },
        { label: "Sakit", value: count.sakit },
        { label: "Piket", value: count.piket },
        { label: "½ Hari", value: count.setengahHari },
        { label: "Cuti", value: count.cuti },
      ].map((item, i) => (
        <div key={i}>
          <div
            style={{
              fontWeight: 700,
              fontSize: 19,
              color: item.highlight
                ? "#a7f3d0"
                : item.color || "#fff",
            }}
          >
            {item.value}
          </div>
          <div style={{ opacity: 0.9, fontSize: 11.5 }}>{item.label}</div>
        </div>
      ))}

      {/* === BAGIAN BAWAH === */}
      <div
        style={{
          gridColumn: "1 / -1",
          marginTop: 16,
          paddingTop: 16,
          borderTop: "1px solid rgba(255,255,255,0.25)",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontSize: 13.5,
            fontWeight: 600,
            marginBottom: 14,
            opacity: 0.9,
          }}
        >
          {formatPeriode()}
        </div>

        <div
          style={{
            display: "flex",
            gap: 16,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {/* Card Kehadiran */}
          <div
            style={{
              flex: "1 1 280px",
              background: "rgba(255,255,255,0.12)",
              padding: "20px 16px",
              borderRadius: 24,
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(255,255,255,0.2)",
              textAlign: "center",
              boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
            }}
          >
            <div style={{ fontSize: 13, opacity: 0.9, marginBottom: 8 }}>
              Presentase Absensi
            </div>
            <div
              style={{
                fontSize: "clamp(32px, 12vw, 52px)",
                fontWeight: 900,
                background:
                  attendanceRate >= 90
                    ? "linear-gradient(135deg, #34d399, #6ee7b7)"
                    : attendanceRate >= 70
                      ? "linear-gradient(135deg, #fbbf24, #fde68a)"
                      : "linear-gradient(135deg, #f87171, #fca5a5)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                lineHeight: 1,
              }}
            >
              {attendanceRate}%
            </div>
          </div>

          {/* Card Uang Makan */}
          {!isFreelance && (
          <div
            style={{
              flex: "1 1 280px",
              background:
                "linear-gradient(135deg, rgba(16,185,129,0.35), rgba(52,211,153,0.25))",
              padding: "20px 16px",
              borderRadius: 24,
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(52,211,153,0.5)",
              textAlign: "center",
              boxShadow: "0 8px 30px rgba(16,185,129,0.35)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                fontSize: 13,
                opacity: 0.95,
                marginBottom: 12,
                position: "relative",
                zIndex: 1,
              }}
            >
              Uang Makan • {count.absenSah} absen sah{" "}
              {count.toleransi > 0 && `(${count.toleransi} toleransi)`}
            </div>

            <div
              style={{
                fontSize: "clamp(20px, 6vw, 28px)",
                fontWeight: 900,
                color: "#ecfdf5",
                zIndex: 1,
                textShadow: "0 3px 10px rgba(0,0,0,0.4)",
              }}
            >
              Rp {totalUangMakan.toLocaleString("id-ID")}
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RekapanCard;
